import { toast } from 'react-toastify'


function ToasterWithMessage() {
  const error = (message: string, delay = 2000) => {
    toast.error(message);
    return true;
  };

  const success = (message: string, delay = 2000) => {
    toast.success(message);
    return true;
  };

  const info =(message: string, delay = 2000) => {
    toast.info(message);
    return true;
  }
  return { error, success, info };
}


export default ToasterWithMessage;
